import type { FilterOption } from '@/components/common-table/FilterSearchBar'
import { getInitialFiltersFromUrl } from '@/lib/filterUtils'
import { create } from 'zustand'

interface DeviceFilterState {
	filters: FilterOption[]
	orGroups: string[][]
	setFilters: (filters: FilterOption[]) => void
	setOrGroups: (groups: string[][]) => void
	clearFilters: () => void
}

function filtersEqual(a: FilterOption[], b: FilterOption[]): boolean {
	if (a === b) {
		return true
	}
	if (a.length !== b.length) {
		return false
	}
	return a.every((f, i) => {
		const g = b[i]
		return f.column === g.column && f.operator === g.operator && f.value === g.value
	})
}

function orGroupsEqual(a: string[][], b: string[][]): boolean {
	if (a === b) {
		return true
	}
	if (a.length !== b.length) {
		return false
	}
	return a.every((group, i) => {
		const other = b[i]
		if (group.length !== other.length) {
			return false
		}
		return group.every((id, j) => id === other[j])
	})
}

export const useDeviceFilterStore = create<DeviceFilterState>((set, get) => ({
	filters: getInitialFiltersFromUrl<FilterOption>(),
	orGroups: [],
	setFilters: filters => set(state => (filtersEqual(state.filters, filters) ? state : { filters })),
	setOrGroups: groups => set(state => (orGroupsEqual(state.orGroups, groups) ? state : { orGroups: groups })),
	clearFilters: () => {
		const { filters, orGroups } = get()
		if (filters.length === 0 && orGroups.length === 0) {
			return
		}
		set({ filters: [], orGroups: [] })
	},
}))
